import { Navigate, Route, Routes } from 'react-router-dom';

import { DefaultLayout2, GuardScope, useAccessGuard } from '@web/app/shared';

import { CatalogDetailPage } from '../pages/detail';
import { CatalogListPage } from '../pages/list';

export const CatalogRoutes = () => {
    useAccessGuard(GuardScope.Project);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<CatalogListPage />} />
                <Route path="/:catalogId" element={<CatalogDetailPage />} />

                <Route path="*" element={<Navigate to="../.." replace></Navigate>}></Route>
            </Route>
        </Routes>
    );
};
